import { createFileRoute } from '@tanstack/react-router';
import { tasks } from './-constants';
import { getUserConversionState } from './-utils';

export const Route = createFileRoute('/_authenticated/onboarding/_ensure-version/')({
  component: () => null,
  pendingComponent: () => <div>Loading...</div>,
  loader: async () => {
    const { tasksToDo, tasksDone } = await getUserConversionState();

    return {
      tasks,
      tasksToDo,
      tasksDone,
    };
  },
});
